const debug = require('debug')('plugin:MessageBus');
const crossvent = require('crossvent');
const Url = require('url');
const endsWith = require('lodash/endsWith');

class MessageBus {
	constructor({source, target, validOrigins}) {
		debug('constructor', validOrigins);
		this.validOrigins = validOrigins || [];
		this.messageHandlers = [];
		// Target can start undefined and set later
		this._target = target || undefined;

		this.validOrigins.forEach((origin) => {
			if (origin.indexOf('http') !== 0) {
				throw new Error('Valid origins MUST begin with a protocol (http/https)');
			}
		});

		if (source && typeof source.postMessage === 'function') {
			this.source = source;
			crossvent.add(this.source, 'message', this.onMessage.bind(this));
			debug('constructor - ready');
		}
	}

	isValidOrigin(origin) {
		debug('isValidOrigin', {origin, validOrigins: this.validOrigins});
		const originUrl = Url.parse(origin);
		return this.validOrigins.some((validOrigin) => {
			const validOriginUrl = Url.parse(validOrigin);
			const host = originUrl.host;
			const validHost = validOriginUrl.host;

			let nonWwwHost = '';

			if (validHost.indexOf('www.') === 0) {
				nonWwwHost = validHost.substring(4);
			} else {
				nonWwwHost = validHost;
			}

			return endsWith(host, nonWwwHost);
		});
	}

	onMessage(e) {
		debug('onMessage', e);
		if (this.isValidOrigin(e.origin)) {
			const data = this.eventDataMap(e);
			this.messageHandlers.forEach((handler) => {
				handler(data);
			});
		} else {
			debug(`${e.origin} is not in the valid origin list ${this.validOrigins}`);
		}
	}

	eventDataMap(e) {
		return {
			data: e.data,
			origin: e.origin,
			source: e.source,
		};
	}

	addMessageHandler(handler) {
		debug('addMessageHandler', handler.name);
		this.messageHandlers.push(handler);
	}

	send({message, origin}) {
		debug('send', message, origin);
		if (this.target) {
			this.target.postMessage(message, origin);
		}
	}

	get target() {
		return this._target;
	}

	set target(target) {
		this._target = target;
	}
}

module.exports = MessageBus;
